import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { QuoteFilterPage } from 'src/app/modals/quote-filter/quote-filter.page';

const routes: Routes = [
    {
        path: '',
        component: QuoteFilterPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [QuoteFilterPage]
})

export class QuoteFilterPageModule { }
